import React from "react";
import { FiPhone } from "react-icons/fi";
import HomepageHero from "./HomepageHero";
import satay from "../assets/images/IMG_8488.jpeg";
import MenuSection from "./MenuSection";
import SiteFooter from "./SiteFooter";
import EventsCalendar from "./EventsCalendar";
import "./RestaurantHome.css";

export default function RestaurantHome() {
  return (
    <div className="restaurant-home">
      <a className="home-skip" href="#home-main">
        Skip to content
      </a>
      <header className="home-header">
        <a href="/" aria-label="nomii home">
          <img src="/elephant-logo.png" alt="nomii" />
        </a>
        <nav aria-label="Main navigation">
          <a href="#menu-heading">The menu</a>
          <a href="#whats-on">What’s on</a>
          <a href="#visit">Find us</a>
        </nav>
        <a className="home-book" href="tel:01434698006">
          <FiPhone aria-hidden="true" />
          Book a table
        </a>
      </header>
      <main id="home-main">
        <HomepageHero />
        <section className="home-menu-layout">
          <div className="home-menu-story">
            <p className="home-eyebrow">01 / OUR FOOD</p>
            <h2>
              At <em>the table.</em>
            </h2>
            <figure>
              <img
                src={satay}
                alt="Grilled chicken satay with peanut sauce and fresh vegetables"
                loading="lazy"
              />
            </figure>
          </div>
          <MenuSection
            takeawayHref="tel:01434698005"
            takeawayPhoneNumber="01434 698005"
          />
        </section>
        <EventsCalendar />
        <section
          className="home-visit"
          id="visit"
          aria-labelledby="visit-title"
        >
          <div>
            <p className="home-eyebrow">03 / FIND US</p>
            <h2 id="visit-title">
              Visit <em>us.</em>
            </h2>
            <p>Lunch and dinner, seven days a week.</p>
            <a className="home-text-link" href="tel:01434698006">
              Book a table <span aria-hidden="true">↗</span>
            </a>
          </div>
          <div className="home-visit-details">
            <p className="home-address">
              26 Priestpopple
              <br />
              Hexham, Northumberland
              <br />
              NE46 1PQ
            </p>
            <a
              className="home-text-link"
              href="https://www.google.com/maps/place/Nomi/@54.9703259,-2.0994631,19.7z/data=!4m15!1m8!3m7!1s0x487dc6467126281d:0x39276823148ef790!2s26+Priestpopple,+Hexham+NE46+1PQ,+UK!3b1!8m2!3d54.9702582!4d-2.0991665!16s%2Fg%2F11dzscwy8m!3m5!1s0x487dc7a7714d31f5:0xb585e9d2f831fbbd!8m2!3d54.9702901!4d-2.0990093!16s%2Fg%2F11zgxqr3lf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get directions <span aria-hidden="true">↗</span>
            </a>
            <details>
              <summary>
                Opening hours <span aria-hidden="true">+</span>
              </summary>
              <dl>
                <div>
                  <dt>Sunday–Thursday</dt>
                  <dd>12–2:30 pm · 5–9:30 pm</dd>
                </div>
                <div>
                  <dt>Friday–Saturday</dt>
                  <dd>12–2:30 pm · 5–10 pm</dd>
                </div>
              </dl>
            </details>
            <details>
              <summary>
                Takeaway <span aria-hidden="true">+</span>
              </summary>
              <p>
                Order your takeaway in store or call{" "}
                <a href="tel:01434698005">01434 698005</a>.
              </p>
              <a href="#menu-heading">Explore the takeaway menu ↗</a>
            </details>
            <details>
              <summary>
                Bookings & enquiries <span aria-hidden="true">+</span>
              </summary>
              <p>
                Call <a href="tel:01434698006">01434 698006</a> to book your
                table.
              </p>
              <p>
                For booking enquiries, email{" "}
                <a href="mailto:bookings@nomii.restaurant">
                  bookings@nomii.restaurant
                </a>
                .
              </p>
            </details>
          </div>
        </section>
      </main>
      <SiteFooter bookingHref="tel:01434698006" phoneNumber="01434 698006" />
    </div>
  );
}
